import {SiteKey} from 'Common/SiteBasics';
import { TheTownieSettings } from 'Shared/frontend/themes/TheTownieSettings';
import { TheDockSettings } from 'Shared/frontend/themes/TheDockSettings';
import { DifferentDrummerSettings } from 'Shared/frontend/themes/DifferentDrummerSettings';
import { IndieIslandSettings } from 'Shared/frontend/themes/IndieIslandSettings';
import { MoshpitSettings } from 'Shared/frontend/themes/MoshpitSettings';
import { FamilySettings } from 'Shared/frontend/themes/FamilySettings';
import { NewVenue1Settings } from 'Shared/frontend/themes/NewVenue1Settings';
import { BrewLabSettings } from 'Shared/frontend/themes/BrewLabSettings';
import { ChippoSettings } from 'Shared/frontend/themes/ChippoSettings';
import { SneakyPossumSettings } from 'Shared/frontend/themes/SneakyPossumSettings';
import { DarlingNikkisSettings } from 'Shared/frontend/themes/DarlingNikkisSettings';
import { BotanyViewSettings } from 'Shared/frontend/themes/BotanyViewSettings';
import { LucillesSettings } from 'Shared/frontend/themes/LucillesSettings';
import { PablosSettings } from 'Shared/frontend/themes/PablosSettings';
import { BaseSettings } from 'Shared/frontend/themes/BaseSettings';


export class VenueSettingsFactory 
{
	createSettings(key:SiteKey): BaseSettings
	{
		let ret: BaseSettings;

		switch(key) {
			case 'BBBBBBBB': ret = new TheTownieSettings(); break;
			case 'CCCCCCCC': ret = new TheDockSettings(); break;
			case 'DDDDDDDD': ret = new DifferentDrummerSettings(); break;
			case 'EEEEEEEE': ret = new IndieIslandSettings(); break;
			case 'FFFFFFFF': ret = new MoshpitSettings(); break;
			case 'GGGGGGGG': ret = new FamilySettings(); break;
			case 'HHHHHHHH': ret = new NewVenue1Settings(); break;
			case 'IIIIIIII': ret = new BrewLabSettings(); break;
			case 'JJJJJJJJ': ret = new ChippoSettings(); break;
			case 'KKKKKKKK': ret = new SneakyPossumSettings(); break;
			case 'LLLLLLLL': ret = new DarlingNikkisSettings(); break;
			case 'MMMMMMMM': ret = new BotanyViewSettings(); break;
			case 'NNNNNNNN': ret = new LucillesSettings(); break;
			case 'OOOOOOOO': ret = new PablosSettings(); break;

			default: throw new Error(`Unknown venue. key: ${key}`);
		}

		return ret;
	}
}

